import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/**
 * Prepends the environment-specific API base URL to relative /api/ requests.
 *
 * In local dev, apiUrl is '' so requests stay relative and are handled by
 * the Angular dev-server proxy. In deployed environments, apiUrl points to
 * the ALB domain (e.g., https://pdmacapgap-api.scicomms.roche.com).
 */
export const apiUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (environment.apiUrl && req.url.startsWith('/api')) {
    req = req.clone({ url: `${environment.apiUrl}${req.url}` });
  }
  return next(req);
};
